import { useMemo } from "react";

type Params = URLSearchParams | { get(name: string): string | null };

function parseBlob(raw: string | null): Record<string, unknown> {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === "object" && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

export function useRedirectParams(searchParams: Params, blobKey = "response") {
  const raw = searchParams.get(blobKey);

  return useMemo(() => {
    const blob = parseBlob(raw);
    return (key: string, aliases: string[] = []) => {
      for (const name of [key, ...aliases]) {
        const v = searchParams.get(name);
        if (v != null && v !== "" && v !== "null") return v;
      }
      for (const name of [key, ...aliases]) {
        const v = blob[name];
        if (v != null && v !== "") return String(v);
      }
      return null;
    };
  }, [raw, searchParams]);
}